import React, { useState } from 'react';
import { ChevronDown } from 'lucide-react';

const faqs = [
  {
    id: 'what-create',
    question: 'What does Whisky Woven create?',
    answer: 'Whisky Woven creates cinematic AI visuals for fantasy authors — character portraits, world and scene imagery, and short video trailers designed to make a story feel instantly alive.',
  },
  {
    id: 'who-for',
    question: 'Who is Whisky Woven for?',
    answer: 'Whisky Woven is for fantasy authors who want visuals with mood, beauty, edge, and atmosphere — especially the ones building rich worlds and unforgettable characters.',
  },
  {
    id: 'get-started',
    question: 'How do I get started?',
    answer: 'Send a message through the inquiry form or email directly. Tell me about your story, your characters, and the feeling you want people to have when they see your world.',
  },
  {
    id: 'book-covers',
    question: 'Do you do book covers?',
    answer: 'No. Whisky Woven is not a book cover service. This work is focused on cinematic visuals, immersive imagery, and video storytelling.',
  },
  {
    id: 'cost',
    question: 'How much does it cost?',
    answer: 'Pricing depends on the scope of the project, the number of deliverables, and what you\'re trying to create. We\'ll talk through that before anything is committed.',
  },
  {
    id: 'timeline',
    question: 'How long does a project take?',
    answer: 'That depends on the project, but once I know what you need, I\'ll give you a clear timeline upfront so you know exactly what to expect.',
  },
];

const FAQItem = ({ faq, isOpen, onToggle }) => (
  <div className="border-b border-[#3d2a5c]/15 last:border-b-0">
    <button
      onClick={onToggle}
      className="w-full flex items-center justify-between py-6 text-left group"
      data-testid={`faq-toggle-${faq.id}`}
    >
      <span className="text-[#F0EDE8] font-medium text-lg pr-4 group-hover:text-[#14B8A6] transition-colors">
        {faq.question}
      </span>
      <ChevronDown
        className={`w-4 h-4 text-[#E8E4DF]/30 flex-shrink-0 transition-transform duration-300 ${isOpen ? 'rotate-180 text-[#14B8A6]' : ''}`}
        strokeWidth={1.5}
      />
    </button>
    <div className={`overflow-hidden transition-all duration-300 ${isOpen ? 'max-h-60 pb-6' : 'max-h-0'}`}>
      <p className="text-[#E8E4DF] pr-8">{faq.answer}</p>
    </div>
  </div>
);

const FAQ = () => {
  const [openIndex, setOpenIndex] = useState(null);

  return (
    <section id="faq" className="py-24 lg:py-36 bg-[#0A0A0B]" data-testid="faq-section">
      <div className="container mx-auto px-6">
        <div className="max-w-2xl mx-auto">
          <div className="text-center mb-12">
            <p className="label-sm text-[#14B8A6] mb-4" data-font="label">FAQ</p>
            <h2 className="text-3xl sm:text-4xl lg:text-5xl font-medium text-[#F0EDE8]" data-testid="faq-heading">
              Questions from the realm
            </h2>
          </div>
          <div>
            {faqs.map((faq, index) => (
              <FAQItem
                key={faq.id}
                faq={faq}
                isOpen={openIndex === index}
                onToggle={() => setOpenIndex(openIndex === index ? null : index)}
              />
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default FAQ;
